import React, {PureComponent} from "react"

import {injectIntl, InjectIntl, FormattedMessage} from "@irati/utils/lang"
import {H3} from "@irati/ui/src/Typography"
import {ReactTable} from "@irati/ui/src/Table"
import Link from "@irati/ui/src/Link"
import buService from "@irati/billing/services/bu"
import authentication from "@irati/auth"
import Loading from "@irati/ui/src/Loading"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {Invoice} from "@irati/types"

import {EmptyData} from "../../Reporting/EmptyData"
import SliderInfo from "../../Dashboard/Integrations/SliderInfo"
import columns from "./columns"

const INITIAL_INVOICES_DISPLAYED_NUM = 5

interface Props extends InjectIntl {}

interface State {
  invoices: Invoice[],
  load: Promise<void>|null,
  downloadLoad: Promise<void>|null,
  invoiceId: string,
  showAll: boolean
}

class Invoices extends PureComponent<Props, State> {
  state = {
    invoices: [],
    load: null,
    downloadLoad: null,
    showAll: false
  }

  componentDidMount()  {
    const load = buService.getInvoices({businessId: authentication.business().uuid}).then(({invoices} : {invoices: Invoice[]}) => {
      this.setState({invoices})
    })
    this.setState({load})
  }

  toggleShowAll = () => {
    this.setState((prevState: State) => ({
      showAll: !prevState.showAll
    }))
  }

  handleInvoiceDownload = (invoiceId: string) => {
    const downloadLoad = buService.getInvoiceBody({invoiceId}).then((res) => {
      const byteNumbers = new Array(res.body.length)
      for (let i = 0; i < res.body.length; i++) {
        byteNumbers[i] = res.body.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const file = new Blob([byteArray], {type: "application/pdf;base64"})
      const url = window.URL.createObjectURL(file)
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", "invoices.pdf")
      link.style.visibility = "hidden"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
    this.setState({downloadLoad, invoiceId})
  }

  getSlidesInfo = () => {
    const {formatMessage} = this.props
    return [
      {
        titleId: "admin.billing.faqs.title",
        subTitleId: <FormattedMessage
          id="admin.billing.faqs.link.body"
          values={{
            link: (
              <Link href={formatMessage({id: "admin.billing.faqs.link.url"})} target="_blank">
                <FormattedMessage id="admin.billing.faqs.link.text" />
              </Link>
            )
          }} />
      },
      {
        titleId: "admin.billing.faqs.help.title",
        subTitleId: <FormattedMessage
          id="admin.billing.faqs.help.body"
          values={{
            link: (
              <Link href={formatMessage({id: "admin.billing.faqs.help.url"})} target="_blank">
                <FormattedMessage id="admin.billing.faqs.help.text" />
              </Link>
            )
          }} />
      }
    ]
  }

  render() {
    const {formatMessage} = this.props
    const {invoices, load, showAll, downloadLoad, invoiceId} = this.state
    const invoicesToRender = showAll || invoices.length < INITIAL_INVOICES_DISPLAYED_NUM
      ? invoices
      : invoices.slice(0, INITIAL_INVOICES_DISPLAYED_NUM)
    const buttonText = showAll ? "admin.reporting.popularPerks.buttons.seeLess" : "admin.reporting.popularPerks.buttons.seeAll"

    return (
      <>
        <H3 marginBottom={3}>
          <FormattedMessage id="admin.billing.title" />
        </H3>
        <Loading load={load}>
          {invoicesToRender?.length
            ? <>
              <ReactTable
                manual={false}
                showPagination={false}
                data={invoicesToRender}
                columns={columns(formatMessage, this.handleInvoiceDownload, downloadLoad, invoiceId)} />
              <Flex justifyContent="center">
                <Button id={showAll ? "seeLessButton" : "seeAllButton"} primary onClick={this.toggleShowAll} marginBottom={3}>
                  <FormattedMessage id={buttonText} />
                  <Icon icon={showAll ? IconTypes.chevronUp : IconTypes.chevronDown} marginLeft />
                </Button>
              </Flex>
              <SliderInfo slides={this.getSlidesInfo()} />
            </>
            : <EmptyData text="admin.billing.empty" /> }
        </Loading>
      </>
    )
  }
}

export default injectIntl(Invoices)
